<script setup lang="ts">
/**
 * Scratch to win: always mounted (app.vue, inside ClientOnly). Owns the
 * automatic opening (useScratchTrigger) and loads the overlay only once the
 * flow has been opened, so no overlay JS, hero image or canvas code ships to
 * visitors who never see it.
 *
 * `useScratchFlowCore`, not `useScratchFlow`: this component is in the entry
 * chunk of every route, and the step machine is not.
 */
const { state } = useScratchFlowCore()
useScratchTrigger()
</script>

<template>
  <LazyScratchOverlay v-if="state.mounted" />
</template>
